/**
 * Brand wordmark. Always renders the brand name as lowercase "deepc",
 * even inside a parent with `uppercase` / `text-transform: uppercase`
 * (e.g. `.eyebrow`, mono tags). Use this anywhere the brand appears
 * inside text that may be CSS-uppercased.
 */
const Brand = ({ className = "" }: { className?: string }) => (
  <span className={`normal-case lowercase ${className}`}>deepc</span>
);

export default Brand;
